import React from 'react';
import { Text, Selection, DetailsList, DetailsListLayoutMode, ICommandBarItemProps, IColumn, MessageBarType, IDetailsListStyles, IDetailsRowProps, Link, mergeStyleSets, DetailsHeader, CommandBar, IButtonProps, ICommandBarStyles, DefaultButton, CommandBarButton, Panel, PanelType, PrimaryButton, MessageBar, IMessageBarProps, Pivot, PivotItem, IPivotStyles } from '@fluentui/react';
import { RootState } from '../../store';
import { IDateTimeField, IField, IFile, IProtocolRegister, IProtocolRegisterRequest } from '../../shared/interfaces';
import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import AppUtilities from '../../shared/Utilities/appUtilities';
import protocolRegistersService from '../../services/protocolRegisters.service';
import CustomCommandBarButton from '../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import Utilities from '../../shared/Utilities/utilities';
import pdfImage from '../../assets/images/pdf.svg';
import axios, { CancelTokenSource } from 'axios';
import { checkRoles } from '../../hoc/CheckRoles';
import { ProtocolRegisterSP_Tipologia, ProtocolRegisterSP_Tipologia_Label, RoleContext } from '../../shared/enums';
import { Unsubscribe } from '@casl/ability';
import abilityBuild from '../../shared/CASL/appAbility';
import DynamicForm from '../DynamicForm/DynamicForm';


const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee', borderTop: '1px solid #eee' },
    primarySet: {
        '& .ms-OverflowSet-item:first-of-type': {
            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '4px'
        },
    },
    secondarySet: {
        '& .ms-OverflowSet-item': {
            display: 'flex', flexFlow: 'row', justifyContent: 'center', padding: '4px'
        }
    }
};

const pivotBarStyles: Partial<IPivotStyles> = {

    root: { padding: '0 24px' },
    itemContainer: { overflow: 'hidden', height: '100%' }
};

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px',
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden',
            },
        },
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '16px',
        maxWidth: '16px',
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px',
    },
    selectionDetails: {
        marginBottom: '20px',
    },
    emptyColumn: {

    }
});

const initialFields: IField[] = [
    {
        dateOnly: true,
        displayName: "Data registro",
        internalName: "DataRegistro",
        sharepointType: "DateTime",
        controlType: "calendar",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        valid: false,
        touched: false,
        rangeMode: true

    } as IDateTimeField
];

const mapState = (state: RootState) => ({
    currentUser: state.sessionReducer.currentUser,
    currentAoo: state.sessionReducer.currentAoo,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
})

const mapDispatch = {

}

const pageSize = 30;

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface ProtocolRegisterState {
    searchPanelIsOpen: boolean;
    commandBarItems: ICommandBarItemProps[];
    columns: IColumn[];
    searchFormFields: IField[];
    items: (IProtocolRegister | null)[];
    dynamicFilters: Partial<IField>[];
    isLoadingProtocolRegisters: boolean;
    messageBarIsVisible: boolean;
    messageBarProps: IMessageBarProps | undefined;
    selectedPivot: string;
    currentPage: number;
}
export interface ProtocolRegisterProps {
}

type Props = ProtocolRegisterProps & RouteComponentProps & PropsFromRedux

class ProtocolRegister extends React.Component<Props, ProtocolRegisterState> {
    cancelTokenSources = {};
    unsubscribeFromAbility: Unsubscribe = () => { };

    constructor(props) {
        super(props);
        this.state = {
            searchPanelIsOpen: false,
            commandBarItems: [],
            items: [],
            columns: [
                {
                    key: 'span',
                    name: '',
                    fieldName: 'span',
                    minWidth: 16,
                    maxWidth: 16,
                    onRender: (item) => {
                        if (item) {
                            return <span></span>
                        }
                    }
                },
                {
                    key: 'document',
                    name: 'document',
                    className: classNames.fileIconCell,
                    iconClassName: classNames.fileIconHeaderIcon,
                    iconName: 'Page',
                    isIconOnly: true,
                    fieldName: 'document',
                    minWidth: 16,
                    maxWidth: 16,
                    onRender: (item) => {
                        if (item) {
                            return <img src={pdfImage} className={classNames.fileIconImg} />
                        }
                    }
                },
                {
                    key: 'Title',
                    name: 'Nome Registro',
                    fieldName: 'Title',
                    minWidth: 150,
                    maxWidth: 500,
                    isResizable: true
                },
                {
                    key: 'DataRegistro',
                    name: 'Data Registro',
                    fieldName: 'DataRegistro',
                    minWidth: 110,
                },
                /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
                /// l'header e i contenuti della tabella 
                {
                    key: 'empty',
                    name: 'empty',
                    fieldName: 'empty',
                    isIconOnly: true,

                    className: classNames.emptyColumn,
                    headerClassName: classNames.emptyColumn,
                    minWidth: 1,
                    maxWidth: 1,
                    onRender: (item) => {

                    },
                },
            ],
            searchFormFields: [...initialFields],
            isLoadingProtocolRegisters: true,
            dynamicFilters: [],
            currentPage: 0,
            messageBarIsVisible: false,
            messageBarProps: {},
            selectedPivot: 'dailyprotocolregister'
        };
    }

    //metodi component
    componentDidMount = () => {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            if (abilityBuild.cannot('read', 'IProtocolRegister')) {
                this.props.history.push({ pathname: '/unauthorized' });
            }
        });

        this.updateCommandBarItems();
        this.getProtocolRegisters();

    }

    componentDidUpdate = (oldProps: Props, oldState: ProtocolRegisterState) => {
        if (oldProps.currentAoo !== this.props.currentAoo) {
            this.getProtocolRegisters();
        }
        if (oldState.selectedPivot !== this.state.selectedPivot) {
            this.setState({ items: [], currentPage: 0, dynamicFilters: [] });
            this.getProtocolRegisters();
        }
        if (oldState.dynamicFilters !== this.state.dynamicFilters) {
            this.updateCommandBarItems();
        }
    }

    componentWillUnmount = () => {
        this.unsubscribeFromAbility();
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
    }

    // metodo per passare di tab
    onPivotItemClick = (item, ev) => {
        this.setState(
            { selectedPivot: item.props.id!, items: [], currentPage: 0, dynamicFilters: [] }
        );
    }

    // metodi chiamate sharepoint (lista e file)
    getProtocolRegisters = () => {
        if (this.props.currentAoo) {
            this.setState({ isLoadingProtocolRegisters: true })
            //cancel token
            this.cancelTokenSources[protocolRegistersService.getProtocolRegisters.name]?.cancel("Request annullata");
            this.cancelTokenSources[protocolRegistersService.getProtocolRegisters.name] = axios.CancelToken.source();

            //creo protocolRegisterRequest qui, gli passo il filtro tipologia e poi costruisco l'intero oggetto
            let typeFilter: Partial<IField>[] = [];

            if (this.state.selectedPivot === 'dailyprotocolregister') {

                typeFilter.push({
                    sharepointType: "Choice",
                    internalName: "Tipologia",
                    internalValue: [ProtocolRegisterSP_Tipologia_Label.get(ProtocolRegisterSP_Tipologia.Giornaliero)]
                })
            } else {
                typeFilter.push({
                    sharepointType: "Choice",
                    internalName: "Tipologia",
                    internalValue: [ProtocolRegisterSP_Tipologia_Label.get(ProtocolRegisterSP_Tipologia.Annuale)]
                })
            }

            let tipologiaToSearchFor;
            if (this.state.selectedPivot === 'dailyprotocolregister') {
                tipologiaToSearchFor = ProtocolRegisterSP_Tipologia.Giornaliero;
            } else {
                tipologiaToSearchFor = ProtocolRegisterSP_Tipologia.Annuale;
            }

            let dataRegistroFilter = this.state.dynamicFilters.find(x => x.internalName === "DataRegistro");
            let dataRegistroDateDa: string = dataRegistroFilter?.internalValue[0];    //check if present
            let dataRegistroDateA: string = dataRegistroFilter?.internalValue[1];

            let protocolRegisterRequest: IProtocolRegisterRequest = {
                pageSize: pageSize,
                dataRegistroA: dataRegistroDateA,
                dataRegistroDa: dataRegistroDateDa,
                tipologia: tipologiaToSearchFor,
                page: this.state.currentPage + 1
            };

            //chiamata
            protocolRegistersService
                .getProtocolRegisters(this.props.currentAoo.id, protocolRegisterRequest, this.cancelTokenSources[protocolRegistersService.getProtocolRegisters.name].token)
                .then(result => {

                    let currentItems = this.state.items.slice();
                    //nuovo array di registri in cui salvo la chiamata
                    let newPageItems: (IProtocolRegister | null)[] = result.protocolRegisters;
                    //aggiungo un item null per far partire onRenderMissingItems
                    if (result.page > 0) {
                        newPageItems.push(null);
                    }

                    this.setState({
                        messageBarIsVisible: false,
                        items: [...currentItems, ...newPageItems],
                        currentPage: result.page,
                        isLoadingProtocolRegisters: false
                    });
                    delete this.cancelTokenSources[protocolRegistersService.getProtocolRegisters.name];
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    }
                    this.setState({
                        isLoadingProtocolRegisters: false,
                        messageBarIsVisible: true,
                        messageBarProps:
                        {
                            //truncated: true,
                            isMultiline: false,
                            overflowButtonAriaLabel: "See more",
                            dismissButtonAriaLabel: "Close",
                            messageBarType: MessageBarType.error,
                            children: `Errore nella ricerca dei registri di protcollo`,
                        }
                    });
                    delete this.cancelTokenSources[protocolRegistersService.getProtocolRegisters.name];
                })

        }
    }

    getProtocolRegisterFile = (item: IProtocolRegister) => {
        if (this.props.currentAoo) {
            this.setState({ isLoadingProtocolRegisters: true });
            //cancel token
            this.cancelTokenSources[protocolRegistersService.getProtocolRegisterFile.name]?.cancel("Request annullata");
            this.cancelTokenSources[protocolRegistersService.getProtocolRegisterFile.name] = axios.CancelToken.source();
            //chiamata
            protocolRegistersService
                .getProtocolRegisterFile(this.props.currentAoo.id, item.id, this.cancelTokenSources[protocolRegistersService.getProtocolRegisterFile.name].token)
                .then(result => {
                    this.downloadDocument(result);
                    this.setState({ isLoadingProtocolRegisters: false });

                    delete this.cancelTokenSources[protocolRegistersService.getProtocolRegisterFile.name];
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    }
                    this.setState({
                        isLoadingProtocolRegisters: false,
                        messageBarIsVisible: true,
                        messageBarProps:
                        {
                            //truncated: true,
                            isMultiline: false,
                            overflowButtonAriaLabel: "See more",
                            dismissButtonAriaLabel: "Close",
                            messageBarType: MessageBarType.error,
                            children: `Errore nella ricerca dei registri di protocollo`,
                        }

                    });
                    delete this.cancelTokenSources[protocolRegistersService.getProtocolRegisterFile.name];
                })
        }
    }

    //metodo per pulsanti commandBar
    updateCommandBarItems = () => {
        let newCommandBarItems: ICommandBarItemProps[] = [];
        if (this.state.selectedPivot === 'dailyprotocolregister') {
            newCommandBarItems.push(
                {
                    key: 'filtri',
                    commandBarButtonAs: () => (

                        <CustomCommandBarButton
                            asDefaultButton={true}
                            text='Filtri'
                            key='Filtri'
                            iconPropsFontAwesome={{ icon: ['far', 'filter'] }}
                            onClick={this.openFilterPanel}
                        />
                    )
                }
            );
        }

        if (this.state.selectedPivot === 'dailyprotocolregister' && this.state.dynamicFilters && this.state.dynamicFilters.length > 0) {
            newCommandBarItems.push({
                key: 'resetFiltri',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Reset filtri'
                        key='resetFiltri'
                        iconPropsFontAwesome={{ icon: ['fal', 'filter-slash'] }}
                        onClick={this.resetSearchHandler}
                    />
                )
            });
        }
        this.setState({ commandBarItems: newCommandBarItems })
    }

    //metodo per il render del contenuto nelle colonne
    renderItemColumn = (item?: IProtocolRegister, index?: number | undefined, column?: IColumn) => {

        let stringValue;
        if (column) {
            const columnName = column.key;
            switch (columnName) {
                case 'Title':
                    stringValue = item === null || item === undefined ? undefined : item.title;
                    break;
                case 'DataRegistro':
                    stringValue = AppUtilities.FormatDate(item?.dataRegistro, true);
                    break;
                default:
                    stringValue = "-";
                    break;
            }

            if (columnName === "Title") {
                return <Link onClick={() => {
                    if (item) {
                        this.getProtocolRegisterFile(item);
                    }
                }
                }>{stringValue}</Link>
            }
            return <span>{stringValue}</span>
        }

    }

    //metodo per il render dell'header di tabella
    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    //metodo per il render degli item di seconda pagina
    onRenderMissingItem = (index?: number | undefined, rowProps?: IDetailsRowProps | undefined): null => {
        let currentItems = this.state.items.slice();
        currentItems.pop();
        this.setState({
            items: currentItems
        }, () => { this.getProtocolRegisters() })
        return null;
    };

    //metodi per aprire e chiudere il panel
    openFilterPanel = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({ searchPanelIsOpen: true })
    }

    dismissFilterPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ searchPanelIsOpen: false })
    }

    //metodo per download del registro
    downloadDocument = (file: IFile) => {
        let fileBase64string = file.docBase64String;
        let fileName = file.fileName;
        if (fileBase64string && fileName) {
            Utilities.SaveFileFromBase64(fileBase64string, fileName);
        }
    }

    //metodo per chiudere il messageBar in caso di errore
    dismissMessageBar = () => {
        this.setState({ messageBarIsVisible: false })
    }

    //metodo per il render nei campi dei filtri
    onInputChangedHandler = (newField: IField) => {
        const updatedFormFields: IField[] = [...this.state.searchFormFields];
        let itemIndex = updatedFormFields.findIndex(e => e.internalName === newField.internalName);
        if (!newField.internalValue) {
            updatedFormFields[itemIndex] = { ...newField, touched: false };
        } else {
            updatedFormFields[itemIndex] = { ...newField };
        }
        this.setState({
            searchFormFields: updatedFormFields
        });
    }

    //metodo per il submit del bottone "cerca" del panel 
    searchLateralPanelSubmit = () => {
        let { searchFormFields } = this.state;
        let touchedFields: IField[] = searchFormFields.filter((el: IField) => el.touched && el.internalValue);
        let fixedFields = AppUtilities.fixFieldsInternalValueForSearchSubmit([...touchedFields]);

        let { dynamicFilters } = this.state;
        if (dynamicFilters) {
            dynamicFilters = [...fixedFields];
        }

        let { currentPage } = this.state;
        if (currentPage) {
            currentPage = 0;
        }

        this.setState({
            searchPanelIsOpen: false,
            isLoadingProtocolRegisters: true,
            items: [],
            dynamicFilters: dynamicFilters,
            currentPage: currentPage
        }, () => {
            this.getProtocolRegisters()
        })
    }

    //metodi per resettare i campi dei filtri
    resetSearchFields = () => {
        let { searchFormFields } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });
        this.setState({ searchFormFields: newSearchFields });
    }

    resetSearchHandler = () => {
        let { searchFormFields } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });
        this.setState({
            searchFormFields: newSearchFields,
            isLoadingProtocolRegisters: true,
            items: [null],
            dynamicFilters: [],
            currentPage: 1
        });

    }

    //metodo per il render dei bottoni nel panel
    onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Cerca"
                    onClick={this.searchLateralPanelSubmit}

                />
                <DefaultButton
                    onClick={() => this.resetSearchFields()}
                    text="Reset filtri"
                />
            </React.Fragment>
        );
    }

    //render di DailyProtocolRegisters
    renderDailyProtocolRegisterList() {
        let dailyType = this.state.items.filter(item => item != null && item.tipologia === ProtocolRegisterSP_Tipologia.Giornaliero);
        return (
            <>
                {(this.state.items.length > 0 && dailyType) &&
                    <DetailsList
                        className="with-empty-column"
                        items={dailyType}
                        columns={this.state.columns}
                        onRenderItemColumn={this.renderItemColumn}
                        onRenderDetailsHeader={this.onRenderDetailsHeader}
                        onRenderMissingItem={this.onRenderMissingItem}
                        layoutMode={DetailsListLayoutMode.justified}
                        selectionMode={0}
                    />
                }
                {(this.state.items.length === 0 || dailyType === undefined) &&

                    <Text block style={{ padding: 25 }}>Nessun risultato trovato.</Text>
                }
            </>
        );
    }

    // render di AnnualProtocolRegisters
    renderAnnualProtocolRegisterList() {
        let annualType = this.state.items.filter(item => item != null && item.tipologia === ProtocolRegisterSP_Tipologia.Annuale);
        return (
            <>
                {(this.state.items.length > 0 && annualType) &&
                    <DetailsList
                        className="with-empty-column"
                        items={annualType}
                        columns={this.state.columns}
                        onRenderItemColumn={this.renderItemColumn}
                        onRenderDetailsHeader={this.onRenderDetailsHeader}
                        onRenderMissingItem={this.onRenderMissingItem}
                        layoutMode={DetailsListLayoutMode.justified}
                        selectionMode={0}
                    />
                }
                {(this.state.items.length === 0 || annualType === undefined) &&

                    <Text block style={{ padding: 25 }}>Nessun risultato trovato.</Text>
                }
            </>
        );
    }

    //render in pagina
    render() {
        return (
            <React.Fragment>
                <div className="daily-protocol-register-component">
                    <CircleLoader loaderClass='loader-large' loading={this.state.isLoadingProtocolRegisters} />

                    <CommandBar
                        overflowButtonProps={overflowProps}
                        items={this.state.commandBarItems}
                        styles={commandBarStyles}
                    />

                    {this.state.messageBarIsVisible &&

                        <MessageBar {...this.state.messageBarProps}
                            onDismiss={this.dismissMessageBar}
                            dismissButtonAriaLabel="Close" />
                    }


                    <Pivot aria-label="Registri di protocollo" styles={pivotBarStyles} className="flex flex-column protocol-regsiter-pivot-component" onLinkClick={this.onPivotItemClick}>

                        <PivotItem id="dailyprotocolregister" headerText="Giornalieri" className="protocol-regsiter-pivot-item flex flex-column">
                            {this.renderDailyProtocolRegisterList()}
                        </PivotItem>

                        <PivotItem id="annualprotocolregister" headerText="Annuali" className="protocol-regsiter-pivot-item flex flex-column">
                            {this.renderAnnualProtocolRegisterList()}
                        </PivotItem>

                    </Pivot>



                    <Panel
                        isLightDismiss
                        isOpen={this.state.searchPanelIsOpen}
                        onDismiss={this.dismissFilterPanel}
                        onRenderFooterContent={this.onRenderLateralPanelFooterContent}
                        headerText={'Filtra per data'}
                        id={'searchFormPanel'}  // l'ID 'searchFormPanel' viene usato nel component INPUT per gestire il click esterno al calendario
                        type={PanelType.custom}
                        customWidth={'550px'}
                        closeButtonAriaLabel="Close"
                        isHiddenOnDismiss={false}
                    >
                        <div className={`search-form-dialog flex flex-column position-relative`}>

                            <div className={`position-relative my-scroll-div`}>

                                <DynamicForm
                                    fields={this.state.searchFormFields}
                                    onInputChangedHandler={(newField) => { this.onInputChangedHandler(newField) }}
                                />
                            </div>

                        </div>
                    </Panel>
                </div>
            </React.Fragment>
        )
    }
}

export default connector(withRouter(checkRoles(ProtocolRegister, RoleContext.Aoo)));
